import i18n from 'i18next';

export const columns = [
  {
    id: 'policy',
    numeric: false,
    disablePadding: true,
    label: i18n.t('common.policy'),
    needSorting: false,
  },
  {
    id: 'name',
    numeric: false,
    disablePadding: false,
    label: i18n.t('common.name'),
    needSorting: false,
  },
  {
    id: 'language',
    numeric: false,
    disablePadding: true,
    label: i18n.t('common.language'),
    needSorting: false,
  },
  {
    id: 'actions',
  },
];

export const languages = [
  {
    label: 'English',
    value: 'en',
  },
  {
    label: 'Spanish',
    value: 'es',
  },
];
